// 9fbef606107a605d69c0edbcd8029e5d
/* istanbul ignore file */
import { call, put, takeEvery } from 'redux-saga/effects';
import styliticsProductListing from '@tcp/core/src/services/abstractors/styliticsProductListing';

import { loadCategoryPageSeoData } from '@tcp/core/src/components/features/browse/ProductListing/container/ProductListing.actions';
import { SEO_DATA } from '@tcp/core/src/reduxStore/constants';
import { getAPIConfig } from '@tcp/core/src/utils';
import constants from './StyliticsProductTabList.constants';
import {
  styliticsProductTabListDataFail,
  styliticsProductTabListDataSuccess,
  isFetchingDataForOutfit,
  styliticsFlushData,
  outfitPLPDataSuccess,
  outfitPLPDataFail,
  setBagOutfitProducts,
} from './StyliticsProductTabList.actions';

export function* fetchStyliticsProductTabListData({ payload }) {
  const { categoryId } = payload;
  try {
    const res = yield call(styliticsProductListing.getData, payload);
    if (res) {
      return yield put(
        styliticsProductTabListDataSuccess({
          [categoryId]: res,
          errors: { [categoryId]: null },
          completed: { [categoryId]: false },
        })
      );
    }
    throw new Error();
  } catch (err) {
    return yield put(
      styliticsProductTabListDataFail({
        [categoryId]: [],
        errors: { [categoryId]: true },
        completed: { [categoryId]: false },
      })
    );
  }
}

const processResponse = (res, categoryId, asPath) => {
  const obj = {
    errors: {},
    asPath,
  };

  if (categoryId?.includes(',')) {
    categoryId?.split(',').forEach((id) => {
      obj[id] = [];
      obj.errors[id] = null;
    });
    categoryId?.split(',').forEach((id) => {
      res.forEach((item) => {
        if (item?.tags?.includes(id)) {
          obj[id].push(item);
          obj.errors[id] = null;
        }
      });
    });
  } else {
    obj[categoryId] = res;
    obj.errors = {
      [categoryId]: null,
    };
  }
  return obj;
};
const formatAndAddSuffix = (str) => {
  return str.replace(/outfits/g, 'outfits_gallery').replace(/-/g, '_');
};
export function* fetchStyliticsProductTabListDataforOutfit({ payload }) {
  const { asPath, newOutFit } = payload;
  const categoryId = payload?.categoryId
    ? formatAndAddSuffix(payload?.categoryId)
    : payload?.categoryId;
  const count = payload?.count;
  try {
    let res;
    if (categoryId) {
      if (newOutFit) {
        yield put(styliticsFlushData({}));
      }
      res = yield call(styliticsProductListing.getData, { categoryId, count });
      const apiConfig = getAPIConfig();
      const splittedCategoryId = categoryId?.split(',');
      for (let i = 0; i < splittedCategoryId.length; i += 1) {
        const seoDataPayload = {
          apiConfig,
          page: splittedCategoryId[i],
          module: SEO_DATA.categorySeoData,
          fromOutfit: true,
        };
        yield put(loadCategoryPageSeoData(seoDataPayload));
      }
    }
    if (res) {
      const parsedData = processResponse(res, categoryId, asPath);
      yield put(outfitPLPDataSuccess(parsedData));
      return yield put(isFetchingDataForOutfit(true));
    }
    throw new Error();
  } catch (err) {
    yield put(isFetchingDataForOutfit(false));
    return yield put(outfitPLPDataFail({ [categoryId]: [], errors: { [categoryId]: true } }));
  }
}

export function* fetchStyliticsBagPageData({ payload }) {
  const { categoryId } = payload;
  try {
    const res = yield call(styliticsProductListing.getData, payload);
    if (res) {
      yield put(
        setBagOutfitProducts({
          bagPageOutfitProducts: res,
          productIds: categoryId,
          errors: null,
        })
      );
    } else throw new Error();
  } catch (err) {
    yield put(
      setBagOutfitProducts({
        bagPageOutfitProducts: [],
        errors: true,
      })
    );
  }
}

function* StyliticsProductTabListSaga() {
  yield takeEvery(constants.STYLITICS_PRODUCT_TAB_LIST_REQ, fetchStyliticsProductTabListData);
  yield takeEvery(
    constants.STYLITICS_PRODUCT_TAB_LIST_REQ_OUTFIT,
    fetchStyliticsProductTabListDataforOutfit
  );
  yield takeEvery(constants.STYLITICS_PRODUCT_TAB_LIST_BAG, fetchStyliticsBagPageData);
}

export default StyliticsProductTabListSaga;
